<template>
  <div class="dup__media__call__btn">
    <b-button
      @click="createNewDeliverableTemplateFromId"
      v-b-tooltip.hover
      title="Duplicate"
      class="duplicate-media-call-btn"
      variant="theme"
    >
      <i class="fas fa-copy"></i>
    </b-button>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: ['deliverableId', 'namespace', 'deliverableTemplateId'],
    computed: {
  	...mapState({
    state (state) {
      return state[this.namespace]
    },
    getDeliverableTemplateSlug (state, getters) {
      return getters['getDeliverableTemplateSlug']
    },
  	}),
  },
  methods: {

  	createNewDeliverableTemplateFromId() {
  	  let that = this;
  	  this.$store.dispatch(this.namespace + "createNewDeliverableTemplateFromId", this.deliverableTemplateId).then(() => {
  	    that.$store.dispatch(that.namespace + "fetchDeliverableTemplates", this.currentPage);
  	    that.$store.dispatch(that.namespace + "fetchDeliverableTemplateCount");

  	    // Accommodate the create deliverableTemplate change
  	    that.$nextTick(() => {
  	      $(".edit-deliverableTemplate-modal .deliverableTemplate-title").trigger("click");
  	    });
  	  });
  	},
  },
};
</script>

<style>
</style>